import React from 'react'
import GroupsIcon from '@mui/icons-material/Groups'
import BaseWidgetProvider from '../../base/BaseWidgetProvider'
import DeviceGroupWidget from './DeviceGroupWidget'

import DeviceGroupConfiguration from './Configuration/DeviceGroupConfiguration'

class DeviceGroupWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'DeviceGroupWidgetProvider'
  getName = () => 'Device Group'
  getIcon = () => GroupsIcon
  createWidget = (props) => <DeviceGroupWidget {...props} />

  getWidgetInfo = (columns, cellHeight) => {
    const size = { defaultW: 6, defaultH: 6, minW: 3, minH: 3 }
    const info = super.getWidgetInfo(columns, cellHeight, size)
    return {
      ...info,
      hideHeader: true,
      availableWithoutDevice: true
    }
  }

  isClickable = () => false
  getConfigurationInfo = () => {
    return []
  }

  /**
   * The hidden list travels wherever the widget configuration travels (RN29), so the default this
   * provider declares is what gets written when a template is created "without copying the
   * settings", when an invalid configuration is reset and when an unreadable one is degraded
   * (RN36). An empty list, never a null nor an object without the key — the group stays unset, as
   * it does today, and the widget keeps asking for one.
   */
  getDefaultConfiguration = () => ({ hiddenDeviceIds: [] })

  createConfigurationWidget = (data, setData, t_) => {
    return (
      <DeviceGroupConfiguration
        data={data}
        setData={setData}
        t_={t_}
      />
    )
  }
}

export default DeviceGroupWidgetProvider
